// API utility functions
import { apiFetch, getApiUrl } from '../config/api';

// Wrapper function to maintain compatibility with existing components
export const fetchWithAuth = async (url, options = {}) => {
  // Convert relative URLs to absolute URLs
  const fullUrl = url.startsWith('/') ? getApiUrl(url) : url;
  return apiFetch(fullUrl, options);
};

// Export other API utilities
export { getApiUrl, apiFetch } from '../config/api';